<template>
  <v-layout>
    <v-card class="project-grid" color="rgba(255,255,255,0)" tile flat>
      <template v-if="recentProjects.length">
        <div class="grid-label">Recently visited</div>
        <div class="recent-panel">
          <project-card
            class="ma-2"
            v-for="p in recentProjects"
            :key="'recent-' + p.id"
            :project="p"
          ></project-card>
        </div>
      </template>
      <project-card
        class="ma-2"
        v-for="p in projects"
        :key="p.id"
        :project="p"
      ></project-card>
      <v-card
        class="ma-2 new-project-card"
        width="186"
        flat
        v-if="canAddProject"
        @click="createProject"
      >
        <div class="new-project-card__inner">
          <v-btn outlined fab small color="white" @click.stop="createProject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <div class="new-project-card__label">New Project</div>
          <div class="new-project-card__hint">Create a new project</div>
        </div>
      </v-card>
    </v-card>
    <new-project-dialog
      :is-visible="newProjectDialogVisible"
      @onClose="handleNewProjectDialogOnClose"
    ></new-project-dialog>
  </v-layout>
</template>

<script>
import ProjectCard from '../components/ProjectCard'
import NewProjectDialog from '@/components/NewProjectDialog'
export default {
  props: {
    projects: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    },
    recentProjects: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  computed: {
    canAddProject() {
      if (
        this.$store.state.UserStore.userRole[0] === 'project_admin' ||
        this.$store.state.UserStore.userRole[0] === 'super_admin'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    NewProjectDialog,
    ProjectCard
  },
  data: function() {
    return {
      newProjectDialogVisible: false
    }
  },
  methods: {
    createProject() {
      this.newProjectDialogVisible = true
    },
    handleNewProjectDialogOnClose() {
      this.newProjectDialogVisible = false
      this.$store.dispatch('ProjectStore/fetchProjects')
    }
  }
}
</script>

<style scoped>
.project-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}
/* Full-width title sits on its own row above the recently-visited cards. */
.grid-label {
  flex: 0 0 100%;
  width: 100%;
  padding: 4px 10px 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
}
/* Lighter rounded panel wraps only the recent cards. No vertical offset, so
   the cards inside line up with the normal cards on the same row. */
.recent-panel {
  align-self: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 1px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.new-project-card {
  border-radius: 12px;
  background: transparent;
  border: 1px dashed rgba(255, 255, 255, 0.22);
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}
.new-project-card:hover {
  border-color: rgba(255, 152, 0, 0.6);
  background: rgba(255, 152, 0, 0.04);
}
.new-project-card__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  min-height: 176px;
  padding: 14px;
}
.new-project-card__label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}
.new-project-card__hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}
</style>
